/** Animated red siren shown on leads that are 5+ days past their stage target. */
export const OverdueSiren = ({ daysOver, threshold = 5, className = "" }) => {
  if (!(Number(daysOver) >= threshold)) return null;
  const d = Math.floor(Number(daysOver));
  return (
    <span
      data-testid="overdue-siren"
      role="img"
      aria-label={`Severely overdue by ${d} days`}
      title={`${d}+ days past stage target`}
      className={`siren-pulse inline-block leading-none ${className}`}
    >
      🚨
    </span>
  );
};

export default OverdueSiren;
